import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'fluxible-router';
import styles from './styles.module.styl';

/* eslint-disable react/no-danger */

const GlossaryTermWdiget = ({ title, definition }) => (
  <div className={styles.widget}>
    <NavLink href="/docs/glossary" className={styles.glossaryLink}>Glossary</NavLink>
    <h3>{title}</h3>
    <p dangerouslySetInnerHTML={{ __html: definition }} />
  </div>
);

GlossaryTermWdiget.propTypes = {
  title: PropTypes.string.isRequired,
  definition: PropTypes.string.isRequired
};

export default GlossaryTermWdiget;

